import type { TranslationRecord } from './types';

/** Name in `lang`, else English, else the first translation that has one. */
export const pickName = (translations: { language: string; name: string }[] | undefined, lang: string): string => {
    const list = translations ?? [];
    return (
        list.find((t) => t.language === lang && t.name)?.name ??
        list.find((t) => t.language === 'en' && t.name)?.name ??
        list.find((t) => t.name)?.name ??
        ''
    );
};

export const mapOf = (translations: TranslationRecord[] | undefined, field: 'name' | 'description'): Record<string, string> =>
    Object.fromEntries((translations ?? []).map((t) => [t.language, t[field] ?? '']));

/** Keeps only languages with a non-empty name, trimmed. */
export const toTranslations = (names: Record<string, string>, descriptions?: Record<string, string>) =>
    Object.entries(names)
        .filter(([, name]) => name.trim() !== '')
        .map(([language, name]) => ({
            language,
            name: name.trim(),
            ...(descriptions ? { description: (descriptions[language] ?? '').trim() } : {}),
        }));

export const PRICE_PATTERN = /^\d{1,8}([.,]\d{1,2})?$/;

/** "12,5" -> "12.50" */
export const normalizePrice = (value: string): string => Number(value.trim().replace(',', '.')).toFixed(2);
